mutation CreatePlatform($input: CreatePlatformInput!) {
  createPlatform(input: $input) {
    id
    createdAt
  }
}

